import { render, staticRenderFns } from "./hospital.vue?vue&type=template&id=0fb72cf0&scoped=true"
import script from "./hospital.vue?vue&type=script&lang=js"
export * from "./hospital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb72cf0",
  null
  
)

export default component.exports